import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/AuthContext";
import firebase from "firebase/app";
import { useHistory } from "react-router";
import getTours from "../requests/getTours";
import createTour from "../requests/createTour";
import ToursTable from "./ToursTable";
import ToursForm from "./ToursForm";
import Alert from "./Alert";

const Tours = () => {
  const history = useHistory();
  const { user, setUser } = useContext(AuthContext);

  const initialState = {
    tourFields: {
      name: "",
      artist: ""
    },
    alert: {
      message: "",
      isSuccess: false
    }
  };

  const [ token, setToken ] = useState("");
  const [ tours, setTours ] = useState([]);
  const [ tourFields, setTourFields ] = useState(initialState.tourFields);
  const [ alert, setAlert ] = useState(initialState.alert);

  useEffect(() => {
    firebase.auth().onAuthStateChanged(function(firebaseUser) {
      if (firebaseUser) {
        setUser(firebaseUser);
        firebaseUser.getIdToken().then(token => {
          setToken(token);
          // console.log("JWT:", token);
        })
      } else {
        history.push("/login");
      }
    });
  }, [history, setUser, user])

  useEffect(() => {
    if (token) {
      getTours(token).then(response => {
        // console.log(response.data);
        setTours(response.data);
      });
    }
  }, [token]);

  const handleFieldChange = (event) => {
    setTourFields((prev) => {
      return {
        ...prev,
        [event.target.name]: event.target.value,
      };
    });
  };

  const handleAddTour = (event) => {
    event.preventDefault();
    if (token) {
      createTour(token, tourFields).then(response => {
        setTours((prev) => [
          ...prev, 
              {
                _id: response.data.insertedId,
                name: tourFields.name,
                artist: tourFields.artist,
                owners: [user.uid],
                editors: [user.uid]
              }
        ]);
      });
    }
    setTourFields(
      {name: "", artist: ""}
    );
  };

  const sendVerificationEmail = () => {
    const currentUser = firebase.auth().currentUser;
    currentUser.sendEmailVerification({
      url: "https://merchsheet.netlify.app"
    })
    .then(() => {
      console.log("Verification email sent");
      setAlert({
        message: "Verification email resent. Please check your email, including your junk folder in case it ends up in there",
      });
    })
    .catch(e => (console.log(e)));
  };

  // console.log("Logging user in the body", user);

  return (
    <div className="container">
      {
        user && !user.emailVerified
        ? 
        <>
        <div className="text-only-info-box">
          <p>You need to verify your email address by clicking the link in the email that was sent when you registered.</p>
          <p>If that email went missing, request a new one below.</p>
          <button
            type="button"
            className="button-link"
            onClick={sendVerificationEmail}
          >
            Send a new verification email.
          </button>
        </div>
        <Alert message={alert.message} />
        </>
        :
        tours.length > 0
        ?
        <>
        <h2 className="heading">Tours</h2>
        <ToursTable tours={tours} />
        <ToursForm
          tourFields={tourFields}
          handleFieldChange={handleFieldChange}
          handleAddTour={handleAddTour}
        />
        </>
        :
        <>
        <h2 className="heading">Tours</h2>
        <div className="text-only-info-box">
        <p><strong>You are not authorised to view any tours yet.</strong></p>
        <p>Create a new Tour using the form below or contact the owner of an existing Tour in our database and ask to be given access rights.</p>
        </div>
        <ToursForm
          tourFields={tourFields}
          handleFieldChange={handleFieldChange}
          handleAddTour={handleAddTour}
        />
        </>
      }
    </div>
  );
}

export default Tours;
